import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchQrAttendanceLogsApi,
  fetchQrTerminalsApi,
  manualOpenAttendanceApi,
  manualCompleteAttendanceApi,
  fetchIncompleteAttendanceLogsApi,
} from "./qrAttendanceLogsApi";

export const fetchQrAttendanceLogs = createAsyncThunk(
  "qrAttendanceLogs/fetchLogs",
  async (workDate, { rejectWithValue }) => {
    try {
      const data = await fetchQrAttendanceLogsApi(workDate);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Devam kayıtları alınamadı."
        );
      }
      return rejectWithValue("Devam kayıtları alınırken bağlantı hatası oluştu.");
    }
  }
);

export const fetchQrTerminals = createAsyncThunk(
  "qrAttendanceLogs/fetchTerminals",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchQrTerminalsApi();
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Terminal listesi alınamadı."
        );
      }
      return rejectWithValue("Terminal listesi alınırken bağlantı hatası oluştu.");
    }
  }
);

export const manualOpenAttendance = createAsyncThunk(
  "qrAttendanceLogs/manualOpen",
  async ({ employeeId, terminalId, checkInTime }, { rejectWithValue }) => {
    try {
      const data = await manualOpenAttendanceApi({ employeeId, terminalId, checkInTime });
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Manuel giriş kaydı açılamadı."
        );
      }
      return rejectWithValue("İşlem sırasında bağlantı hatası oluştu.");
    }
  }
);

export const manualCompleteAttendance = createAsyncThunk(
  "qrAttendanceLogs/manualComplete",
  async ({ id, checkOutTime }, { rejectWithValue }) => {
    try {
      const data = await manualCompleteAttendanceApi({ id, checkOutTime });
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Manuel çıkış kaydı tamamlanamadı."
        );
      }
      return rejectWithValue("İşlem sırasında bağlantı hatası oluştu.");
    }
  }
);

export const fetchIncompleteAttendanceLogs = createAsyncThunk(
  "qrAttendanceLogs/fetchIncomplete",
  async ({ branchId }, { rejectWithValue }) => {
    try {
      const data = await fetchIncompleteAttendanceLogsApi(branchId);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Açık kalan kayıtlar alınamadı."
        );
      }
      return rejectWithValue("Açık kalan kayıtlar alınırken bağlantı hatası oluştu.");
    }
  }
);
